import { getFilters } from '@/help.search';
import * as cpfHelp from '@/cpf.help';
import Help from "@/Help";
import OpeningHours from '@/openingHours';
export default class Popup {
    static createPopup(data) {
        if (Help.isMobileDevice()) { //TODO:TD this means no icons etc on iPad Pro.... so should be media Q based instead
            return `<div class="popup mobile">
				<h4>${data.name}</h4>
			</div>`;
        }
        else {
            return `<div class="popup">
		        <h4>${data.name}</h4>
		        <div class="attributes">
		            ${this.createPopupAttributes(data)}
		        </div>
		        <div class="popup_icon">
		            <div class="icon"><i class="fas fa-parking"></i></div><div class="content">${this.getAllSpaces(data)} spaces</div>
		        </div>
		        <div class="popup_icon">
		            <div class="icon"><i class="far fa-clock"></i></div><div class="content">${OpeningHours.getSummary(data)}</div>
		        </div>
			</div>`;
        }
    }
    static createPopupAttributes(data) {
        const allFilters = getFilters();
        const popupAttributes = data.filters.map(i => allFilters[i]).map(f => this.createPopupAttribute(f));
        return popupAttributes.join('');
    }
    static createPopupAttribute(filterData) {
        return `<div id="${cpfHelp.idify(filterData.name)}" class="attribute selected" title="${filterData.description}"><div class="icon"><i class="fas ${filterData.faIcon}"></i></div></div>`;
    }
    static getAllSpaces(data) {
        return data.disabledSpaces + data.ecpSpaces + data.parentChildSpaces + data.standardSpaces;
    }
}
